<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';
import { required } from '@/_core/utils/forms/validators';
import { uuid } from '@/_core/utils/uuid';
import { AddNewProduct } from '@/api/manageProducts/commands';
import { commandDispatcher } from '@/_core/cqrs';

interface IProps {
    isOpen: boolean;
}

const AddNewProductDialog = defineComponent({
    name: 'AddNewProductDialog',
    props: { isOpen: Boolean },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({
            name: null as string,
            isSaving: false,
        });

        const onCreate = async () => {
            if (state.name.trim().length == 0 || state.name.trim().length > 200) {
                return;
            }
            state.isSaving = true;

            const id = await uuid.create();
            const res = await commandDispatcher.dispatchCommand(new AddNewProduct(id, state.name.trim()));

            state.isSaving = false;

            if (res.IsSuccess) {
                ctx.emit('productAdded', id, state.name.trim(), res.Slug);
                onClose();
            }
        };

        const onClose = () => {
            ctx.emit('close');
        };

        return {
            state,
            required,
            onCreate,
            onClose,
        };
    },
});

export default AddNewProductDialog;
</script>

<template>
  <AppDialog
    title="New product"
    :isOpen="isOpen"
    :width="600"
    @close="onClose"
  >
    <v-card-text class="pb-2 pt-0">
      <v-text-field
        v-model="state.name"
        solo-inverted
        flat
        :disabled="state.isSaving"
        placeholder="product name"
        autofocus
        :rules="[required()]"
        counter="200"
        @keydown.native.enter="onCreate"
      />
    </v-card-text>
    <v-card-actions class="d-flex pt-0 px-6">
      <v-spacer />
      <v-btn
        color="primary"
        depressed
        class=""
        :loading="state.isSaving"
        @click="onCreate"
      >
        Create
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<style lang='scss' scoped></style>